/*
 * languageReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author tfrazzet
 * @since 21-Oct-2024
 */

import { produce } from 'immer'
import { actionTypes } from '../actions/language'

const ACTION_HANDLERS = {
  [actionTypes.DO_LANGUAGE_CHANGE]: produce((draft, action) => {
    draft.currentLanguage = action.payload
  })
  // @generator reducer:type:action
}

// The initial state of the language
const initialState = {
  currentLanguage: window.localStorage.getItem('userLanguage')
}

const language = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default language
